import React from 'react';

function SongContent(props) {
    return (
        <div>SongContent</div>
    );
}

export default SongContent;